export enum StatusCode {
  Forbidden = 403,
  InternalServerError = 500,
  NetworkAuthenticationRequired = 511,
  TooManyRequests = 429,
  Unauthorized = 401,
  UnprocessableEntity = 422,
}
